import { OpeningApplicantCardFragment } from '@src/graphql/generated';
import { hasFields } from '@src/util/object/helpers';

type OpeningApplicant = Extract<OpeningApplicantCardFragment, { __typename?: 'OpeningApplicantType' }>;

export function isOpeningApplicantType(applicant: OpeningApplicantCardFragment): applicant is OpeningApplicant {
  return hasFields<OpeningApplicant>(applicant, ['__typename']) && applicant.__typename === 'OpeningApplicantType';
}
